import React from "react";
import { Card, Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";

import Col from "react-bootstrap/Col";
import { useDispatch, useSelector } from 'react-redux';
import { setDisconnection,fetchDataServiceMeterCategory,notificationDetails } from './stateManegement/dispatch';
import { useForm } from "react-hook-form"

export default function Disconnection({ userData }) {
  const [errorsMasterValue, setErrorsMasterValue] = useState({});
  const dispatch = useDispatch();
  const { loading, serviceAndMeterCat, apierror,returnData } = useSelector((state) => state.notificatinReducer);
  useEffect(() => {
    dispatch(fetchDataServiceMeterCategory(userData));
  }, [dispatch]);
  
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm()
  const [inputValues, setInputValues] = useState({});
  const [getAlldetails, setGetAlldetails] = useState({
  })
  const [inputValues2, setInputValues2] = useState({});
  const [inputValues3, setInputValues3] = useState({});
  const [inputValues4, setInputValues4] = useState({});
  const [meterBalanceValue, setMeterBalanceValue] = useState({})
  const [hourlyValue, sethourlyValue] = useState({})
  const [dailyValue, setDailyValue] = useState({})
  const [monthlyValue, setmonthlyValue] = useState({})

  const [selectedOption, setSelectedOption] = useState("MeterBalanceEveryEvent");
  const [selectedOption2, setSelectedOption2] = useState("AvgHourlychrgEveryEvent");
  const [selectedOption3, setSelectedOption3] = useState("AvgDailychrgEveryHours");
  const [selectedOption4, setSelectedOption4] = useState("AvgMonthlychrgEveryDay");
  const [creditLimitObj, setCreditLimitObj] = useState({
    CREDITLIMIT: true,
    EMERGENCYCREDITLIMIT:false
  })
  const [checkedRows, setCheckedRows] = useState({
    MeterBalance: true,
    AvgHourlychrg: false,
    AvgDailychrg: false,
    AvgMonthlychrg: false,
    
  });
  const [balanceValue, setBalanceValue] = useState({
    MeterBalance: "",
    AvgHourlychrg: "",
    AvgDailychrg: "",
    AvgMonthlychrg: "",
  });
 // Function to reset all values
 const resetAllValues = () => {
  // Reset selected options
  setSelectedOption("MeterBalanceEveryEvent");
  setSelectedOption2("AvgHourlychrgEveryEvent");
  setSelectedOption3("AvgDailychrgEveryHours");
  setSelectedOption4("AvgMonthlychrgEveryDay");
  setCreditLimitObj({
    creditLimit: true,
    emergencyCreditLimit:false
  })
  // Reset checked rows
  setCheckedRows({
    METERBALANCE: true,
    AVGHOURLYCHARGES: false,
    AVGDAILYCHARGES: false,
    AVGMONTHLYCHARGES: false,
  });

  // Reset balance values
  setBalanceValue({
    MeterBalance: "",
    AvgHourlychrg: "",
    AvgDailychrg: "",
    AvgMonthlychrg: "",
  });
};
  const validateForm = () => {
    const newErrors = {};
    // if (!newTariffFormData?.TariffName) newErrors.TariffName = 'Tariff Name required';
    // if (!newTariffFormData?.TariffDescription) newErrors.TariffDescription = 'Tariff Description required';
    // if (!newTariffFormData?.TariffServiceCategory) newErrors.TariffServiceCategory = 'Tariff Service Category required';
    // if (!newTariffFormData?.TariffServiceTypeCategory) newErrors.TariffServiceTypeCategory = 'Tariff Service Type Category required';
    // if (!newTariffFormData?.TariffSubCategoryCategory) newErrors.TariffSubCategoryCategory = 'Tariff Sub Category Category required';
    // if (!newTariffFormData?.TariffFixedUnit) newErrors.TariffFixedUnit = 'Tariff Fixed Unit required';
    // if (!newTariffFormData?.TariffFixedSubsidy) newErrors.TariffFixedSubsidy = 'Tariff Fixed Subsidy required';
    // if (!newTariffFormData?.TariffFixedCharges) newErrors.TariffFixedCharges = 'Tariff Fixed Charges required';
    // if (!newTariffFormData?.TariffFixedMinimumCharges) newErrors.TariffFixedMinimumCharges = 'Tariff Minimum Charges required';
    // if (!newTariffFormData?.TariffFixedMaximumCharges) newErrors.TariffFixedMaximumCharges = 'Tariff Maximum Charges required';
    return newErrors;
  };
  const handleBalanceValue = (value) => (e) => {
    setGetAlldetails({
      ...getAlldetails,
      [value]: e.target.value,
    });
  };
  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   const formErrors = validateForm();

  //   if (Object.keys(formErrors).length > 0) {
  //     setErrorsMasterValue(formErrors);
  //   } else {
  //     setErrorsMasterValue({});
  //   }
  // };
  const onSubmit = async (data) => {
    console.log(getAlldetails)
    
    const {
      STATE_NAME: state,
      CIRCLE_NAME: district,
      CIRCLE_CODE: circleCode,
      USERNAME: userName
    } = userData.pDATASET[0];
  
    const getNotificationFrequency = (everyEvent = 0, everyHours = "", everyDays = "") => ({
      everyEvent,
      everyHours,
      everyDays,
    });
  
    const newObj = {
      state,
      district,
      circleCode,
      userName,
      serviceCategory: data.serviceCategory,
      meterCategory: data.meterCategory,
      parametersConsideration: {
        creditLimit: getAlldetails.CREDITLIMIT ? 1 : 0, // true => 1, false => 0
        emergencyCreditLimit: getAlldetails.EMERGENCYCREDITLIMIT ? 1 : 0,
      },
      balanceConsideration: {
        meterBalance: {
          enabled: getAlldetails.METERBALANCEENABLED ? 1 : 0,
          value: getAlldetails.METERBALANCE ? getAlldetails.METERBALANCE : '',
          notificationFrequency: getNotificationFrequency(getAlldetails.METERBALANCEEVENT ? 1 : 0 , getAlldetails.METERBALANCEHOUR || '', getAlldetails.METERBALANCEDAYS || ''),
        },
        avgHourlyCharges: {
          enabled: getAlldetails.AVGHOURLYCHARGESENABLED  ? 1 : 0,
          value: getAlldetails.AVGHOURLYCHARGES ? getAlldetails.AVGHOURLYCHARGES : '',
          notificationFrequency: getNotificationFrequency(getAlldetails.AVGHOURLYCHARGESEVENT ? 1 : 0, getAlldetails.AVGHOURLYCHARGESHOUR || '', getAlldetails.AVGHOURLYCHARGESDAYS || ''),
        },
        avgDailyCharges: {
          enabled: getAlldetails.AVGDAILYCHARGESENABLED ? 1 : 0, 
          value: getAlldetails.AVGDAILYCHARGES ? getAlldetails.AVGDAILYCHARGES : "",
          notificationFrequency: getNotificationFrequency(getAlldetails.AVGDAILYCHARGESEVENT ? 1 : 0, getAlldetails.AVGDAILYCHARGESHOUR || '', getAlldetails.AVGDAILYCHARGESDAYS || ''),
        },
        avgMonthlyCharges: {
          enabled: getAlldetails.AVGMONTHLYCHARGESENABLED ? 1 : 0,
          value: getAlldetails.AVGMONTHLYCHARGES ? getAlldetails.AVGMONTHLYCHARGES : "",
          notificationFrequency: getNotificationFrequency(getAlldetails.AVGMONTHLYCHARGESEVENT ? 1 : 0, getAlldetails.AVGMONTHLYCHARGESHOUR || '', getAlldetails.AVGMONTHLYCHARGESDAYS || ''),
        },
      },
    };
  
    try {
      await dispatch(setDisconnection(userData, newObj));
      window.alert("Diconnnection submitted successfully!");
      dispatch(fetchDataServiceMeterCategory(userData));
      reset();
      setValue()
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const handleCheck = (row) => (e) => {
    const isChecked = e.target.checked;

    // Handle specific cases based on the row value
    const eventDetails = {};
    switch (row) {
        case "METERBALANCEENABLED":
            eventDetails["METERBALANCEEVENT"] = isChecked;
            break;
        case "AVGHOURLYCHARGESENABLED":
            eventDetails["AVGHOURLYCHARGESEVENT"] = isChecked;
            break;
        case "AVGDAILYCHARGESENABLED":
            eventDetails["AVGDAILYCHARGESHOUR"] = 2;
            break;
        case "AVGMONTHLYCHARGESENABLED":
            eventDetails["AVGMONTHLYCHARGESDAYS"] = 3;
            break;
        default:
            break;
    }

    // Update getAlldetails state with the row's event
    setGetAlldetails((prevState) => ({
        ...prevState,
        ...eventDetails,
        [row]: isChecked ? 1 : 0, // Update the specific row with either 1 or 0 based on isChecked
    }));

};

const handleCheckboxChange = (event, type) => {
  const { name, checked, value } = event.target;
  const commonReset = {
      "METERBALANCEEVENT": 0,
      "METERBALANCEHOUR": 0,
      "METERBALANCEDAYS": 0,
      "AVGHOURLYCHARGESEVENT": 0,
      "AVGHOURLYCHARGESHOUR": 0,
      "AVGHOURLYCHARGESDAYS": 0,
      "AVGDAILYCHARGESEVENT": 0,
      "AVGDAILYCHARGESHOUR": 0,
      "AVGDAILYCHARGESDAYS": 0,
      "AVGMONTHLYCHARGESEVENT": 0,
      "AVGMONTHLYCHARGESHOUR": 0,
      "AVGMONTHLYCHARGESDAYS": 0
  };

  const updateState = (resetFields) => {
      setGetAlldetails((prevDetails) => ({
          ...prevDetails,
          [name]: checked ? 1 : 0,  // Update the checkbox field
          ...resetFields,           // Reset related fields
      }));
  };

  const resetValues = (resetHoursKey, resetDaysKey) => {
      setValue(resetHoursKey, false);
      setValue(resetDaysKey, false);
  };

  switch (type) {
      case "MeterBalance":
          setSelectedOption(name);
          if (name === "METERBALANCEEVENT") {
              updateState({ "METERBALANCEHOUR": 0, "METERBALANCEDAYS": 0 });
              resetValues("MeterBalanceEveryHours", "MeterBalanceEveryDay");
          } else if (name === "METERBALANCEHOUR") {
              updateState({ "METERBALANCEEVENT": 0, "METERBALANCEDAYS": 0 });
              resetValues("MeterBalanceEveryEvent", "MeterBalanceEveryDay");
          } else {
              updateState({ "METERBALANCEEVENT": 0, "METERBALANCEHOUR": 0 });
              resetValues("MeterBalanceEveryHours", "MeterBalanceEveryEvent");
          }
          break;

      case "AvgHourlychrg":
          setSelectedOption2(value);
          if (name === "AVGHOURLYCHARGESEVENT") {
              updateState({ "AVGHOURLYCHARGESHOUR": 0, "AVGHOURLYCHARGESDAYS": 0 });
              resetValues("AvgHourlychrgEveryHours", "AvgHourlychrgEveryDay");
          } else if (name === "AVGHOURLYCHARGESHOUR") {
              updateState({ "AVGHOURLYCHARGESEVENT": 0, "AVGHOURLYCHARGESDAYS": 0 });
              resetValues("AvgHourlychrgEveryEvent", "AvgHourlychrgEveryDay");
          } else {
              updateState({ "AVGHOURLYCHARGESEVENT": 0, "AVGHOURLYCHARGESHOUR": 0 });
              resetValues("AvgHourlychrgEveryHours", "AvgHourlychrgEveryEvent");
          }
          break;

      case "AvgDailychrg":
          setSelectedOption3(value);
          if (name === "AVGDAILYCHARGESEVENT") {
              updateState({ "AVGDAILYCHARGESHOUR": 0, "AVGDAILYCHARGESDAYS": 0 });
              resetValues("AvgDailychrgEveryHours", "AvgDailychrgEveryDay");
          } else if (name === "AVGDAILYCHARGESHOUR") {
              updateState({ "AVGDAILYCHARGESEVENT": 0, "AVGDAILYCHARGESDAYS": 0 });
              resetValues("AvgDailychrgEveryEvent", "AvgDailychrgEveryDay");
          } else {
              updateState({ "AVGDAILYCHARGESEVENT": 0, "AVGDAILYCHARGESHOUR": 0 });
              resetValues("AvgDailychrgEveryHours", "AvgDailychrgEveryEvent");
          }
          break;

      case "AvgMonthlychrg":
          setSelectedOption4(value);
          if (name === "AVGMONTHLYCHARGESEVENT") {
              updateState({ "AVGMONTHLYCHARGESHOUR": 0, "AVGMONTHLYCHARGESDAYS": 0 });
              resetValues("AvgMonthlychrgEveryHours", "AvgMonthlychrgEveryDay");
          } else if (name === "AVGMONTHLYCHARGESHOUR") {
              updateState({ "AVGMONTHLYCHARGESEVENT": 0, "AVGMONTHLYCHARGESDAYS": 0 });
              resetValues("AvgMonthlychrgEveryEvent", "AvgDailychrgEveryDay");
          } else {
              updateState({ "AVGMONTHLYCHARGESHOUR": 0, "AVGMONTHLYCHARGESEVENT": 0 });
              resetValues("AvgMonthlychrgEveryHours", "AvgMonthlychrgEveryEvent");
          }
          break;

      default:
          break;
  }
};

  const handleCreadLimit = (type) => (e) =>{
    setCreditLimitObj({
      ...creditLimitObj,
      [type.toLocaleUpperCase()]: e.target.checked,
    });
  
    setGetAlldetails({
      ...getAlldetails,
      [type.toLocaleUpperCase()]:e.target.checked,
    })
  }
  const handleInput = (event, type) => {
    const value = event.target.value;
    const name = event.target.name;
    console.log(name)
    setGetAlldetails({
      ...getAlldetails,
      [name]:value,
    })

  };



    // Watch the values of both selects
const ServiceCategory = watch("serviceCategory");
const MeterCategory = watch("meterCategory");
  const handleSelectChange = async (ServiceCategory, MeterCategory) => {
    try {
      // Wait for the dispatch to complete
      let apiID = 5
      await dispatch(notificationDetails(userData, ServiceCategory, MeterCategory,apiID));
    
     
    } catch (error) {
      // Handle error if needed
      console.error("An error occurred:", error);
    }
  };
  useEffect(() => {
    if (returnData?.pDATASET?.[0]) {
      setGetAlldetails(returnData.pDATASET[0]);
      console.log("Disconnection value updated:", returnData.pDATASET[0]);
    }else{
      setGetAlldetails(returnData?.pDATASET?.[0]);
    }
  }, [returnData]);

// Call `handleSelectChange` whenever `ServiceCategory` or `MeterCategory` changes
useEffect(() => {
  if (ServiceCategory?.length != 0 && MeterCategory?.length != 0) {  // Ensure these are not undefined or null
    handleSelectChange(ServiceCategory,MeterCategory);
  }

}, [ServiceCategory, MeterCategory]);  // Include userData as a dependency
  return (
    <>
      <Card
        style={{
          height: "auto",
          width: "100%",
          backgroundColor: "#17234D",
          borderRadius: "0px",
        }}
      >
        <Card.Body>
          <Card.Title
            style={{
              color: "#fff",
              fontFamily: "Roboto-Regular",
              fontSize: "25px",
            }}
          >
            Notification Management - Disconnect
          </Card.Title>
        </Card.Body>
      </Card>

      <div className="TriffContainer">
        <Card
          style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", margin: "30px" }}
        >
          <Card className="custom_card">
            <>
              {" "}
              <div className="custom_container">
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Card className="custom_top_container">
                    <Row>
                      <Col className="customtitle" sm={2}>
                        {" "}
                        State
                      </Col>
                      <Col className="customtitle" sm={2}>
                        {" "}
                        Distict
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={2} style={{ fontFamily: "Roboto-Regular ", fontSize: '15px' }} >
                  <input className="inputHide" defaultValue={userData.pDATASET[0].STATE_NAME}   value={userData.STATE_NAME} /> 
                  
                  </Col>
                  <Col sm={2} style={{ fontFamily: "Roboto-Regular", fontSize: '15px' }}  >
                  <input className="inputHide"   defaultValue={userData.pDATASET[0].CIRCLE_NAME}  value={userData.CIRCLE_NAME}  /> 
                  
                  </Col>
                    </Row>{" "}
                  </Card>
                  <div className="customContainer">
                    <div style={{display:"flex", gap:"20px"}}>
                      <div className="mb-3 gap-5 dropdowncustom">
                        <Form.Group>
                          <Form.Label>Service Category</Form.Label>
                          <Form.Select {...register("serviceCategory",{ required: "This required." })} aria-label="Default select example">
                            <option value="">Select Service Category</option>
                            {serviceAndMeterCat?.pDATASET?.filter(item => item.TYPE === "SERVICECATEGORY").map(service => (
                              <option key={service.ID} value= {service.ID}>
                               {service.NAME}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.serviceCategory && <span className="error">This field required</span>}
                        </Form.Group>
                      </div>
                      <div className="mb-3 gap-5 dropdowncustom">
                        <Form.Group>
                          <Form.Label>Meter Category</Form.Label>
                          <Form.Select {...register("meterCategory")} aria-label="Default select example">
                            <option value="">Select Meter Category</option>
                            {serviceAndMeterCat?.pDATASET?.filter(item => item.TYPE === "METERCATEGORY").map(meter => (
                              <option key={meter.ID} value={meter.ID}>
                                {meter.NAME}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.meterCategory && <span className="error">This field required</span>}
                        </Form.Group>
                      </div>
                    </div>
                   

                    <div className="mb-3 pt-3 row_card">
                      <h6>Parameters Consideration</h6>
                      <div className="paramerts">
                        <div className="parametersFlex">
                          <p>Credit Limit</p>
                          <div class="checkboxes__item">
                            <label class="checkbox style-b">
                              <input type="checkbox" {...register("creditLimit")} checked={getAlldetails?.CREDITLIMIT ? getAlldetails?.CREDITLIMIT: creditLimitObj.creditLimit} onChange={handleCreadLimit("CREDITLIMIT")}/>
                              <div class="checkbox__checkmark"></div>
                            </label>
                          </div>
                        </div>
                        <div className="parametersFlex">
                          <p>Emergency Credit Limit</p>
                          <div class="checkboxes__item">
                            <label class="checkbox style-b">
                              <input type="checkbox" {...register("emergencyCreditLimit")}   checked={getAlldetails?.EMERGENCYCREDITLIMIT ? true: false} onChange={handleCreadLimit("EMERGENCYCREDITLIMIT")}/>
                              <div class="checkbox__checkmark"></div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3 pt-3 row_card">
                      <div className="par_card">
                        <div className="checkwithinput">
                          <h6>Balance Consideration </h6>

                          <Form.Group className="checkinput">
                            <Form.Check
                              type="checkbox"
                              {...register("meterBalance")}
                              inline
                              label="Meter Balance"
                              name="MeterBalance"
                              checked={getAlldetails?.METERBALANCEENABLED}
                              onChange={handleCheck("METERBALANCEENABLED")} // Handle specific row
                            />
                            <div className="checkin">
                              <span>&#60;=</span>
                              <Form.Control
                                type="text"
                                {...register("MeterBalanceValue",{required:getAlldetails?.METERBALANCEENABLED ? false : getAlldetails?.METERBALANCEENABLED} )} 
                                value={getAlldetails?.METERBALANCEENABLED ? getAlldetails?.METERBALANCE: ""}
                                onChange={handleBalanceValue("METERBALANCE")}
                                placeholder="0"
                                disabled={!getAlldetails?.METERBALANCEENABLED}
                              />
                              <span>Rs</span>
                              {errors.MeterBalanceValue && <span className="error">required</span>}
                            </div>
                           
                          </Form.Group>
                          <Form.Group className="checkinput">
                            <Form.Check
                              inline
                              {...register("AvgHourlychrg")}
                              label="Avg Hourly charges"
                              name="AvgHourlychrg"
                            
                              checked={getAlldetails?.AVGHOURLYCHARGESENABLED}
                              onChange={handleCheck("AVGHOURLYCHARGESENABLED")} // Handle specific row
                            />
                            <div className="checkin">
                            <span>&#60;=</span>
                              <Form.Control
                                type="text"
                                {...register("AvgHourlychrgValue",{required:getAlldetails?.AVGHOURLYCHARGESENABLED ? false : getAlldetails?.AVGHOURLYCHARGESENABLED})} 
                                value={getAlldetails?.AVGHOURLYCHARGESENABLED ? getAlldetails?.AVGHOURLYCHARGES:""}
                                onChange={handleBalanceValue("AVGHOURLYCHARGES")}
                                disabled={!getAlldetails?.AVGHOURLYCHARGESENABLED}
                                placeholder="Value"
                                maxLength={2}
                              />
                              <span>%</span>
                              {errors.AvgHourlychrgValue && <span className="error">required</span>}
                            </div>
                          </Form.Group>

                          <Form.Group className="checkinput">
                            <Form.Check
                              inline
                              {...register("AvgDailychrg")} 
                              label="Avg Daily charges"
                              name="AvgDailychrg"

                              checked={getAlldetails?.AVGDAILYCHARGESENABLED}
                              onChange={handleCheck("AVGDAILYCHARGESENABLED")} // Handle specific row
                            />
                              <div className="checkin">
                              <span>&#60;=</span>
                              <Form.Control
                                 {...register("AvgDailychrgValue",{required:getAlldetails?.AVGDAILYCHARGESENABLED ? false : getAlldetails?.AVGDAILYCHARGESENABLED })}
                              type="text"
                              value={getAlldetails?.AVGDAILYCHARGESENABLED ? getAlldetails?.AVGDAILYCHARGES:""}
                            
                              onChange={handleBalanceValue("AVGDAILYCHARGES")}
                              disabled={!getAlldetails?.AVGDAILYCHARGESENABLED}
                              placeholder="Value"
                              maxLength={2}
                            />
                              <span>%</span>
                              {errors.AvgDailychrgValue && <span className="error">required</span>}
                              </div>
                          
                          </Form.Group>

                          <Form.Group className="checkinput">
                            <Form.Check
                              inline
                              {...register("AvgMonthlychrg")} 
                              label="Avg Monthly charges"
                              name="AvgMonthlychrg"
                              
                              checked={getAlldetails?.AVGMONTHLYCHARGESENABLED}
                              onChange={handleCheck("AVGMONTHLYCHARGESENABLED")} // Handle specific row
                              
                            />
                             <div className="checkin">
                             <span>&#60;=</span>
                             <Form.Control type="text"
                              {...register("AvgMonthlychrgValue",{required:getAlldetails?.AVGMONTHLYCHARGESENABLED ? false : getAlldetails?.AVGMONTHLYCHARGESENABLED})}
                              
                              disabled={!getAlldetails?.AVGMONTHLYCHARGESENABLED}
                              value={getAlldetails?.AVGMONTHLYCHARGESENABLED ? getAlldetails?.AVGMONTHLYCHARGES:""}
                              placeholder="Value"
                              onChange={handleBalanceValue("AVGMONTHLYCHARGES")}
                              maxLength={2}
                            />
                             <span>%</span>
                             {errors.AvgMonthlychrgValue && <span className="error">required</span>}
                             </div>
                            
                          </Form.Group>
                        </div>

                        <div className="checkBoxs">
                          <h6 style={{paddingBottom:"40px"}}>Notification Frequency</h6>

                          <div className={getAlldetails?.METERBALANCEENABLED ? "divHeight" : "d-none"}>
                          <p>Meter Balance Details</p>
                            <div className="checkrows">
                             
                                <Form.Group>
                                  <Form.Check
                                    inline
                                    checked={getAlldetails?.METERBALANCEEVENT }
                                    {...register("METERBALANCEEVENT")} 
                                    label="Every Event"
                                    name="METERBALANCEEVENT"
                                    onChange={(e) => handleCheckboxChange(e, "MeterBalance")}
                                    // defaultChecked={true}
                                  />
                                </Form.Group>
                                <div className="checkBoxinput">
                                  <Form.Check 
                                    inline
                                    {...register("METERBALANCEHOUR")}
                                        
                                    label="Every "
                                    name="METERBALANCEHOUR"
                                    checked={getAlldetails?.METERBALANCEHOUR}
                                    onChange={(e) => {handleCheckboxChange(e, "MeterBalance")}}
                                  />
                                 <Form.Control
                                    as="select"
                                    className="everyInput"
                                    {...register("METERBALANCEHOUR", { required: getAlldetails?.METERBALANCEHOUR ? false : getAlldetails?.METERBALANCEHOUR  })}
                                    name="METERBALANCEHOUR"
                                    value={getAlldetails?.METERBALANCEHOUR ? getAlldetails?.METERBALANCEHOUR : ""}
                                    onChange={(e) => handleInput(e, "MeterBalanceEveryHours")}
                                    disabled={!getAlldetails?.METERBALANCEHOUR}
                                  >
                                    <option value="">Select an hour</option> {/* Placeholder option */}
                                    {[...Array(24)].map((_, i) => (
                                      <option key={i + 1} value={i + 1}>{i + 1}</option>
                                    ))}
                                  </Form.Control>
                                  {errors.METERBALANCEHOUR && <span className="error">required</span>}
                                  <span>Hours</span>

                                
                                </div>
                                <div className="checkBoxinput">
                                  <Form.Check
                                    inline
                                    {...register("MeterBalanceEveryDay")}
                                    label="Every"
                                    checked={getAlldetails?.METERBALANCEDAYS}
                                    name="METERBALANCEDAYS"
                                    onChange={(e) => {handleCheckboxChange(e, "MeterBalance")
                                   
                                    }}
                                  />
                                <Form.Control
                                  as="select"
                                  className="everyInput"
                                  {...register("METERBALANCEDAYS", { required: getAlldetails?.METERBALANCEDAYS ? false :getAlldetails?.METERBALANCEDAYS })}
                                  name="METERBALANCEDAYS"
                                  value={getAlldetails?.METERBALANCEDAYS ? getAlldetails?.METERBALANCEDAYS :''}
                                  onChange={(e) => handleInput(e, "MeterBalanceEveryDay")}
                                  disabled={!getAlldetails?.METERBALANCEDAYS}
                                >
                                  <option value="">Select a day</option> {/* Placeholder option */}
                                  {[...Array(30)].map((_, i) => (
                                    <option key={i + 1} value={i + 1}>{i + 1}</option>
                                  ))}
                                </Form.Control>
                                {errors.METERBALANCEDAYS && <span className="error">required</span>}
                                <span>Day</span>
                                </div>
                            </div>
                          </div>
                          <div className={getAlldetails?.AVGHOURLYCHARGESENABLED ? "divHeight" : "d-none"} >
                          <p>Avg Hourly Charges </p>
                            <div className="checkrows">
                                <Form.Group>
                                  <Form.Check
                                      
                                    inline
                                    {...register("AVGHOURLYCHARGESEVENT")}
                                    label="Every Event"
                                    name="AVGHOURLYCHARGESEVENT"
                                    checked={getAlldetails?.AVGHOURLYCHARGESEVENT }
                                    onChange={(e) => handleCheckboxChange(e, "AvgHourlychrg")}
                                  />
                                </Form.Group>
                            
                                <div className="checkBoxinput">
                                  <Form.Check
                                    inline
                                    {...register("AVGHOURLYCHARGESHOUR")} 
                                    
                                    label="Every"
                                    name="AVGHOURLYCHARGESHOUR"
                                    checked={getAlldetails?.AVGHOURLYCHARGESHOUR}
                                    onChange={(e) => handleCheckboxChange(e, "AvgHourlychrg")}
                                   
                                  />
                                <Form.Control
                                  as="select"
                                  className="everyInput"
                                  {...register("AVGHOURLYCHARGESHOUR", { required: getAlldetails?.AVGHOURLYCHARGESHOUR ? false : getAlldetails?.AVGHOURLYCHARGESHOUR })}
                                  name="AVGHOURLYCHARGESHOUR"
                                  value={getAlldetails?.AVGHOURLYCHARGESHOUR ? getAlldetails?.AVGHOURLYCHARGESHOUR : ''}
                                  onChange={(e) => handleInput(e, "AvgHourlychrgEveryHours")}
                                  disabled={!getAlldetails?.AVGHOURLYCHARGESHOUR}
                                >
                                  <option value="">Select an hour</option> {/* Placeholder option */}
                                  {[...Array(24)].map((_, i) => (
                                    <option key={i + 1} value={i + 1}>{i + 1}</option>
                                  ))}
                                </Form.Control>
                                {errors.AVGHOURLYCHARGESHOUR && <span className="error">required</span>}
                                <span>Hours</span>

                                </div>
                              
                              
                                <div className="checkBoxinput">
                                  <Form.Check
                                    inline
                                    {...register("AVGHOURLYCHARGESDAYS")}
                                    label="Every"
                                    name="AVGHOURLYCHARGESDAYS"
                                    checked={getAlldetails?.AVGHOURLYCHARGESDAYS}
                                    onChange={(e) => handleCheckboxChange(e, "AvgHourlychrg") }
                                
                                  />
                                <Form.Control
                                    as="select"
                                    className="everyInput"
                                    {...register("AVGHOURLYCHARGESDAYS", { required: getAlldetails?.AVGHOURLYCHARGESDAYS ? false : getAlldetails?.AVGHOURLYCHARGESDAYS })}
                                    name="AVGHOURLYCHARGESDAYS"
                                    value={getAlldetails?.AVGHOURLYCHARGESDAYS ? getAlldetails?.AVGHOURLYCHARGESDAYS: ''}
                                    onChange={(e) => handleInput(e, "AvgHourlychrgEveryDay")}
                                    disabled={!getAlldetails?.AVGHOURLYCHARGESDAYS}
                                  >
                                    <option value="">Select a day</option> {/* Placeholder option */}
                                    {[...Array(30)].map((_, i) => (
                                      <option key={i + 1} value={i + 1}>{i + 1}</option>
                                    ))}
                                  </Form.Control>
                                  {errors.AVGHOURLYCHARGESDAYS && <span className="error">required</span>}
                                  <span>Day</span>

                                </div>
                              
                            </div>
                          </div>
                          <div className={getAlldetails?.AVGDAILYCHARGESENABLED ? "divHeight" : "d-none"} >
                          <p>Avg Daily Charges </p>
                            <div className="checkrows">
                                <Form.Group>
                                  <Form.Check
                                    inline
                                    {...register("AVGDAILYCHARGESEVENT")}
                                    label="Every Event"
                                    name="AVGDAILYCHARGESEVENT"
                                    checked={getAlldetails?.AVGDAILYCHARGESEVENT }
                                   
                                    onChange={(e) => handleCheckboxChange(e, "AvgDailychrg") }
                                  />
                                </Form.Group>
                            
                              
                                <div className="checkBoxinput">
                                  <Form.Check 
                                    inline
                                    {...register("AVGDAILYCHARGESHOUR")} 
                                    label="Every"
                                    name="AVGDAILYCHARGESHOUR"
                                    checked={getAlldetails?.AVGDAILYCHARGESHOUR }
                               
                                    onChange={(e) => handleCheckboxChange(e, "AvgDailychrg") }
                                  />
                                <Form.Control
                                as="select"
                                className="everyInput"
                                {...register("AVGDAILYCHARGESHOUR", { required: getAlldetails?.AVGDAILYCHARGESHOUR ? false : getAlldetails?.AVGDAILYCHARGESHOUR })}
                                name="AVGDAILYCHARGESHOUR"
                                value={getAlldetails?.AVGDAILYCHARGESHOUR ? getAlldetails?.AVGDAILYCHARGESHOUR : ''}
                                onChange={(e) => handleInput(e, "AvgDailychrgEveryHoursValue")}
                                disabled={!getAlldetails?.AVGDAILYCHARGESHOUR}
                              >
                                <option value="">Select an hour</option> {/* Placeholder option */}
                                {[...Array(24)].map((_, i) => (
                                  <option key={i + 1} value={i + 1}>{i + 1}</option>
                                ))}
                              </Form.Control>
                              {errors.AVGDAILYCHARGESHOUR && <span className="error">required</span>}
                              <span>Hours</span>

                                </div>
                              
                              
                                <div className="checkBoxinput">
                                  <Form.Check
                                    inline
                                    label="Every"
                                 
                                    {...register("AVGDAILYCHARGESDAYS")} 
                                    name="AVGDAILYCHARGESDAYS"
                                    checked={getAlldetails?.AVGDAILYCHARGESDAYS }
                                    onChange={(e) => handleCheckboxChange(e, "AvgDailychrg") }
                                  />
                                  <Form.Control
                                    as="select"
                                    className="everyInput"
                                    {...register("AVGDAILYCHARGESDAYS",{required:getAlldetails?.AVGDAILYCHARGESDAYS ? false : getAlldetails?.AVGDAILYCHARGESDAYS})}
                                    name="AVGDAILYCHARGESDAYS"
                                    value={getAlldetails?.AVGDAILYCHARGESDAYS ? getAlldetails?.AVGDAILYCHARGESDAYS : ''}
                                    onChange={(e) => handleInput( e, "AvgDailychrgEveryDayValue" )}
                                    disabled={!getAlldetails?.AVGDAILYCHARGESDAYS}
                                  >
                                    <option value="">Select a day</option> {/* Placeholder option */}
                                    {[...Array(30)].map((_, i) => (
                                      <option key={i + 1} value={i + 1}>{i + 1}</option>
                                    ))}
                                  </Form.Control>
                                  {errors.AVGDAILYCHARGESDAYS && <span className="error">required</span>}
                                  <span>Day</span>
                                </div>



                              
                            </div>
                          </div>
                          <div className={getAlldetails?.AVGMONTHLYCHARGESENABLED ? "divHeight" : "d-none" }>
                          <p>Avg Monthly Charges </p>
                            <div className="checkrows">
                                <Form.Group>
                                  <Form.Check
                                    inline
                                    label="Every Event"
                                    {...register("AVGMONTHLYCHARGESEVENT")}
                                    onChange={(e) =>  handleCheckboxChange(e, "AvgMonthlychrg") }
                                    name="AVGMONTHLYCHARGESEVENT"
                                    checked={getAlldetails?.AVGMONTHLYCHARGESEVENT }
                                  
                                  />
                                </Form.Group>
                                <div className="checkBoxinput">
                                  <Form.Check
                                    inline
                                        
                                    label="Every"
                                    {...register("AVGMONTHLYCHARGESHOUR")} 
                             
                                    name="AVGMONTHLYCHARGESHOUR"
                                    checked={getAlldetails?.AVGMONTHLYCHARGESHOUR }
                               
                                    onChange={(e) => handleCheckboxChange(e, "AvgMonthlychrg") }


                                    
                                  />
                                
                                
                                  <Form.Control
                                as="select"
                                className="everyInput"
                                {...register("AVGMONTHLYCHARGESHOUR",{required:getAlldetails?.AVGMONTHLYCHARGESHOUR ? false : getAlldetails?.AVGMONTHLYCHARGESHOUR})}
                                name="AVGMONTHLYCHARGESHOUR"
                                value={getAlldetails?.AVGMONTHLYCHARGESHOUR ? getAlldetails?.AVGMONTHLYCHARGESHOUR:''}
                                onChange={(e) => handleInput( e, "AvgMonthlychrgEveryHours" )}
                                disabled={!getAlldetails?.AVGMONTHLYCHARGESHOUR}
                              >
                                <option value="">Select an hour</option> {/* Placeholder option */}
                                {[...Array(24)].map((_, i) => (
                                  <option key={i + 1} value={i + 1}>{i + 1}</option>
                                ))}
                              </Form.Control>
                              {errors.AVGMONTHLYCHARGESHOUR && <span className="error">required</span>}
                              <span>Hours</span>
                                </div>
                                <div className="checkBoxinput">
                                  <Form.Check
                                    inline
                                   
                                    {...register("AVGMONTHLYCHARGESDAYS")} 
                                    label="Every"
                                    name="AVGMONTHLYCHARGESDAYS"
                                    checked={getAlldetails?.AVGMONTHLYCHARGESDAYS }
                                    onChange={(e) => handleCheckboxChange(e, "AvgMonthlychrg")}
                                  />
                                  <Form.Control
                                    as="select"
                                    className="everyInput"
                                    {...register("AVGMONTHLYCHARGESDAYS",{required:getAlldetails?.AVGMONTHLYCHARGESDAYS ? false : getAlldetails?.AVGMONTHLYCHARGESDAYS})} 
                                     name="AVGMONTHLYCHARGESDAYS"
                                     value={getAlldetails?.AVGMONTHLYCHARGESDAYS ? getAlldetails?.AVGMONTHLYCHARGESDAYS :''}
                                     onChange={(e) => handleInput( e, "AvgMonthlychrgEveryDay" )}
                                     disabled={!getAlldetails?.AVGMONTHLYCHARGESDAYS}
                                  >
                                    <option value="">Select a day</option> {/* Placeholder option */}
                                    {[...Array(30)].map((_, i) => (
                                      <option key={i + 1} value={i + 1}>{i + 1}</option>
                                    ))}
                                  </Form.Control>
                                  {errors.AVGMONTHLYCHARGESDAYS && <span className="error">required</span>}
                                  <span>Day</span>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex gap-3" style={{ marginTop: 40, marginLeft: "10px" }}>
                    <div className="btn_div" >

<button className="btn btn-primary"
  type="button"
  onClick={() => {
    reset(); // Clears all form fields to default (empty) values
  }}
>
  Clear All
</button>

<input className="btn btn-primary" type="submit" value="SUBMIT" />
{/* <Button variant="primary" onClick={handleSubmit}>Submit</Button> */}
</div>
       
                  </div>
                  </div>
                 
                </Form>
              </div>
            </>
          </Card>
        </Card>
      </div>
    </>
  );
}
